import { datadogLogs } from '@datadog/browser-logs';

import { getApi, gql } from '@wetransfer/transfer/apollo-api/src';
import ErrorHandler from '@wetransfer/transfer/modules/error-handler';

export interface TransferResponse {
  id: string;
}

const UPDATE_TRANSFER_PASSWORD = gql`
  mutation UpdateTransferPassword($input: UpdateTransferPasswordInput!) {
    updateTransferPassword(input: $input) {
      result {
        id
      }
    }
  }
`;

export const updateTransferPassword = async (
  transferId: string,
  password: string
): Promise<{
  transfer: TransferResponse;
}> => {
  const api = getApi();

  let result: TransferResponse;

  try {
    ({
      data: {
        updateTransferPassword: { result },
      },
    } = await api.mutate({
      mutation: UPDATE_TRANSFER_PASSWORD,
      variables: {
        input: {
          transferId,
          password,
        },
      },
    }));
  } catch (e) {
    datadogLogs.logger.error(e.toString(), {
      method: 'updateTransferPassword',
      stack_trace: e.stack,
      transfer_id: transferId,
    });

    ErrorHandler.track(e);
  }

  if (result === null || result === undefined) {
    throw new Error('No transfer data returned');
  }

  return { transfer: result };
};
